{
	"agents": [
		{
			"agentType": "grok",
			"accountId": "712020:mock-agent-grok",
			"displayName": "Grok session",
			"views": 96,
			"created": 4,
			"updated": 2,
			"commentCreated": 1,
			"searchPerformed": 0,
			"relatedUserAccountId": "712020:mock-human-alex",
			"relatedUserDisplayName": "Alex Rivera",
			"lastViewedAt": "2026-08-21T15:04:00.000Z"
		},
		{
			"agentType": "github_copilot",
			"accountId": "712020:mock-agent-github-copilot",
			"displayName": "Copilot session",
			"views": 88,
			"created": 3,
			"updated": 1,
			"commentCreated": 0,
			"searchPerformed": 0,
			"relatedUserAccountId": "712020:mock-human-alex",
			"relatedUserDisplayName": "Alex Rivera",
			"lastViewedAt": "2026-08-21T14:50:00.000Z"
		},
		{
			"agentType": "vscode",
			"accountId": "712020:mock-agent-vscode",
			"displayName": "VS Code session",
			"views": 81,
			"created": 2,
			"updated": 2,
			"commentCreated": 0,
			"searchPerformed": 1,
			"relatedUserAccountId": "712020:mock-human-alex",
			"relatedUserDisplayName": "Alex Rivera",
			"lastViewedAt": "2026-08-21T14:20:00.000Z"
		},
		{
			"agentType": "open_code",
			"accountId": "712020:mock-agent-open-code",
			"displayName": "Open Code session",
			"views": 74,
			"created": 1,
			"updated": 0,
			"commentCreated": 0,
			"searchPerformed": 0,
			"relatedUserAccountId": "712020:mock-human-sam",
			"relatedUserDisplayName": "Sam Chen",
			"lastViewedAt": "2026-08-21T13:40:00.000Z"
		},
		{
			"agentType": "kiro",
			"accountId": "712020:mock-agent-kiro",
			"displayName": "Kiro session",
			"views": 61,
			"created": 2,
			"updated": 1,
			"commentCreated": 0,
			"searchPerformed": 0,
			"relatedUserAccountId": "712020:mock-human-sam",
			"relatedUserDisplayName": "Sam Chen",
			"lastViewedAt": "2026-08-21T13:10:00.000Z"
		},
		{
			"agentType": "hermes",
			"accountId": "712020:mock-agent-hermes",
			"displayName": "Hermes session",
			"views": 67,
			"created": 5,
			"updated": 3,
			"commentCreated": 2,
			"searchPerformed": 0,
			"relatedUserAccountId": "712020:mock-human-sam",
			"relatedUserDisplayName": "Sam Chen",
			"lastViewedAt": "2026-08-21T12:45:00.000Z"
		}
	]
}
